<template>
    <div>

        <vue-headful title="MIC Types :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                <li class="breadcrumb-item active">MIC Types</li>
                <li class="ml-3">
                    <router-link :to="`/admin/hse-types-edit`" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> New</router-link>
                </li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <hse-type-list />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {

            }
        },

        methods: {

        },
    }
</script>
